export const createApiFetch =
  (fetchFn: typeof fetch) => async (path: string, init?: RequestInit) => {
    const url = `/api${path.startsWith("/") ? path : `/${path}`}`;
    const method = (init?.method ?? "GET").toUpperCase();
    const body = init?.body;
    const sendsBody =
      body !== undefined && body !== null && (typeof body !== "string" || body.length > 0);
    const defaultJsonContentType =
      method !== "GET" && method !== "HEAD" && sendsBody
        ? { "content-type": "application/json" }
        : {};
    const nextInit: RequestInit = {
      ...init,
      credentials: "include",
      headers: {
        ...defaultJsonContentType,
        ...(init?.headers ?? {})
      }
    };
    return fetchFn(url, nextInit);
  };

export const apiFetch = createApiFetch(globalThis.fetch.bind(globalThis));
